import React from 'react';

import styled from 'styled-components';

import { SkeletonLine } from '~/techstyle-shared/react-components';

const SkeletonWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const AssetCardSkeleton = () => {
  return (
    <SkeletonWrapper>
      <SkeletonLine width="100%" height="100%" />
    </SkeletonWrapper>
  );
};

export default AssetCardSkeleton;
